import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { appRoutes, pathUrl } from '@adex/shared/routing/routes'


const routes: Routes = [
  {
    path: pathUrl(appRoutes.auth.main, 1),
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: pathUrl(appRoutes.app.main, 1),
    loadChildren: () => import('./core/core.module').then(m => m.CoreModule)
  },
  {
    path: '',
    redirectTo: pathUrl(appRoutes.auth.main, 1),
    pathMatch: 'full'
  },
  // {
  //   path: '**',
  //   redirectTo: pathUrl(appRoutes.auth.main, 1),
  //   pathMatch: 'full'
  // }
]


@NgModule({
  imports: [ RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    onSameUrlNavigation: 'reload'
  }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {
}
